var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnsupported(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 78,
    viewBox: "0 0 220 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 220,
    height: 78,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.98,
    y: -254,
    width: 13,
    height: 560,
    transform: "rotate(45 209.98 -254)",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.519,
    y: -180.461,
    width: 13,
    height: 560,
    transform: "rotate(45 283.519 -180.461)",
    fill: "#242b3b"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.749,
    y: -217.23,
    width: 13,
    height: 560,
    transform: "rotate(45 246.749 -217.23)",
    fill: "#242b3b"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.288,
    y: -143.691,
    width: 13,
    height: 560,
    transform: "rotate(45 320.288 -143.691)",
    fill: "#242b3b"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.365,
    y: -235.615,
    width: 13,
    height: 560,
    transform: "rotate(45 228.365 -235.615)",
    fill: "#242b3b"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.904,
    y: -162.076,
    width: 13,
    height: 560,
    transform: "rotate(45 301.904 -162.076)",
    fill: "#242b3b"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.134,
    y: -198.846,
    width: 13,
    height: 560,
    transform: "rotate(45 265.134 -198.846)",
    fill: "#242b3b"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338.673,
    y: -125.307,
    width: 13,
    height: 560,
    transform: "rotate(45 338.673 -125.307)",
    fill: "#242b3b"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.058,
    y: -106.922,
    width: 13,
    height: 560,
    transform: "rotate(45 357.058 -106.922)",
    fill: "#242b3b"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.443,
    y: -88.537,
    width: 13,
    height: 560,
    transform: "rotate(45 375.443 -88.537)",
    fill: "#242b3b"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 220,
    height: 78,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnsupported);
export default __webpack_public_path__ + "static/media/unsupported.92981a23c8d96fdcdfa1c9971c62dfe3.svg";
export { ForwardRef as ReactComponent };